import { Component, ViewChild, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CronOptions } from '../../scheduler/CronOptions';
import { TimezonePickerComponent } from '../../scheduler/timezone-picker/timezone-picker.component';
import * as moment from 'moment-timezone';
import * as cronstrue from 'cronstrue';
import { TranslateService } from '@ngx-translate/core';
import { AdvancedTimingsComponent } from '../../scheduler/advanced-timings/advanced-timings.component';
import { Schedule } from '../../survey.Service';
import { ProcessService } from '../../process.Service';
import { BasicTimePickerComponent } from '../../scheduler/basic-time-picker/basic-time-picker.component';
import { TimezonePickerService } from '../../scheduler/timezone-picker/timezone.service';
import { DatetimeAdapter } from '../../scheduler/datetime-adapter';

@Component({
  selector: 'app-task-scheduler',
  templateUrl: './task-scheduler.component.html',
  styleUrl: './task-scheduler.component.css'
})
export class TaskSchedulerComponent implements OnInit {

  @ViewChild('startTime') public startTime: AdvancedTimingsComponent | undefined;
  @ViewChild('endTime') public endTime: AdvancedTimingsComponent | undefined;
  @ViewChild('repeatTimePicker') public repeatTimePicker: BasicTimePickerComponent | undefined;
  @ViewChild('durationTimePicker') public durationTimePicker: BasicTimePickerComponent | undefined;

  defaultTimezone: string = TimezonePickerService.guess();
  tz: number = 0;
  isDirty: boolean = false;
  startingSelected: boolean = false;

  fb: FormBuilder = new FormBuilder();
  formGroup: FormGroup;
  dailyForm: FormGroup;
  weeklyForm: FormGroup;
  monthlyForm: FormGroup;
  timings: FormGroup;
  advancedForm: FormGroup;

  logChanges: boolean = true;

  public state: any;
  public selectOptions = this.getSelectOptions();

  public options: CronOptions = {
    defaultTime: '00:00:00',
    hideOnceTab: false,
    hideMinutesTab: false,
    hideHourlyTab: false,
    hideDailyTab: false,
    hideWeeklyTab: false,
    hideMonthlyTab: false,
    hideYearlyTab: false,
    hideAdvancedTab: false,
    hideSpecificWeekDayTab: false,
    hideSpecificMonthWeekTab: false,

    use24HourTime: true,
    hideSeconds: false,

    cronFlavor: 'quartz'
  };

  constructor(public translate: TranslateService,
    private datetimeAdapter: DatetimeAdapter<Date>,
    private processService: ProcessService) {
    this.state = this.getDefaultState();
    this.formGroup = this.fb.group({
      interval: ['once'],
      hours: [],
      minutes: [],
      seconds: [],
    });
    this.state = this.getDefaultState();
  }

  ngOnInit(): void {
  }

  setupForm(): void {
    this.timings = this.fb.group({
      start: [this.start],
      end: [this.end],
    });
    this.timings.valueChanges.subscribe((result) => {
      //if (this.start != this.timings.controls.start.value) {
        this.start = this.timings.controls.start.value;
      /*  let starting = this.advancedForm.controls.starting as FormGroup;
        starting.controls.hours.setValue(this.start.getHours());
        starting.controls.minutes.setValue(this.start.getMinutes());
        starting.controls.at.setValue(this.start.getHours() + ":" + this.start.getMinutes());
      }*/

      this.end = this.timings.controls.end.value;
      this.computeForTab();
    });

    this.prevCron = "";
    this.handleModelChange(this.cron);
    const [defaultHours, defaultMinutes] =
      this.options.defaultTime.split(":").map(Number);

    this.dailyForm = this.fb.group({
      days: [this.state.daily.days]
    });
    this.dailyForm.valueChanges.subscribe((value) => {
      this.computeDailyCron(value);
      this.scheduleChange.emit(this.schedule);
    });

    this.weeklyForm = this.fb.group({
      weeks: [this.state.weekly.weeks],
      MON: [this.state.weekly.MON],
      TUE: [this.state.weekly.TUE],
      WED: [this.state.weekly.WED],
      THU: [this.state.weekly.THU],
      FRI: [this.state.weekly.FRI],
      SAT: [this.state.weekly.SAT],
      SUN: [this.state.weekly.SUN],
    });
    this.weeklyForm.valueChanges.subscribe((value) => {
      this.computeWeeklyCron(value);
      this.scheduleChange.emit(this.schedule);
    });
    this.monthlyForm = this.fb.group({
      months: [this.state.monthly.months],
      subTab: this.state.monthly.subTab,
      specificDays: this.fb.group({
        days: [this.state.monthly.specificDays.days],
      }),
      specificDaysOfWeek: this.fb.group({
        on: [this.state.monthly.specificDaysOfWeek.on],
        weekDays: [this.state.monthly.specificDaysOfWeek.weekDays]
      }),
    });
    this.monthlyForm.valueChanges.subscribe((value) => {
      this.computeMonthlyCron(value);
      this.scheduleChange.emit(this.schedule);
    });
    this.advancedForm = this.fb.group({
      repeatSelected: [this.state.repeatSelected],
      repeat: this.fb.group({
        hours: [this.state.repeat.hours],
        minutes: [this.state.repeat.minutes],
      }),
      startingSelected: this.startingSelected,
      starting: this.fb.group({
        hours: [this.state.starting.hours],
        minutes: [this.state.starting.minutes],
        hourType: [this.state.starting.hourType],
        at: [this.state.starting.at],
      }),
      duration: this.fb.group({
        days: [this.state.duration.days],
        hours: [this.state.duration.hours],
        minutes: [this.state.duration.minutes],
      })
    });
    /*if (this.state.repeatSelected) {
      this.advancedForm.controls.repeat.enable();
      this.advancedForm.controls.duration.enable();
    }
    else {
      this.advancedForm.controls.repeat.disable();
      this.advancedForm.controls.duration.disable();
    }*/

    this.repeatTimePicker?.calculateSelection();
    this.durationTimePicker?.calculateSelection();

    this.setStartingAt(this.state);
    this.advancedForm.valueChanges.subscribe((value) => {
      if (!this.logChanges) return;
      this.logChanges = false;
      this.setStartingAt(value);
      this.logChanges = true;
      this.computeForTab()
    });

    this.computeForTab();
  }

  private setStartingAt(state: any) {
    if (this.advancedForm.controls.startingSelected.value) {
      //this.advancedForm.controls.starting.enable();
      let starting = this.advancedForm.controls.starting as FormGroup;
      if (starting.controls.at.value == null) {
        this.setStartTime(starting);
        this.state.starting.at = starting.controls.at.value;
        this.state.starting.hours = parseInt(starting.controls.hours.value);
        this.state.starting.minutes = parseInt(starting.controls.minutes.value);
      }
      else {
        let time = state.starting.at.split(":");
        this.state.starting.at = state.starting.at;
        this.state.starting.hours = parseInt(time[0]);
        this.state.starting.minutes = parseInt(time[1]);
      }
    }

    this._starttime = this.state.starting.at;
    this.startingSelected = this.state.startingSelected = state.startingSelected;
    this.state.duration = state.duration;
    this.state.repeat = state.repeat;
    this.state.repeatSelected = state.repeatSelected;
  }

  private setStartTime(control: any) {
    let parsedHours = this.start.getHours();
    let parsedMinutes = this.start.getMinutes().toString();
    let hours = this.getAmPmHour(parsedHours);
    let minutes = parseInt(parsedMinutes, 10);
    let hourType = this.getHourType(parsedHours);
    if (hourType == undefined) {
      hourType = "";
    }

    let miniState = {
      hours: hours,
      minutes: minutes,
      hourType: hourType,
      at: hours + ":" + minutes
    };
    control.setValue(miniState);
  }

  private getDefaultState() {
    const [defaultHours, defaultMinutes] =
      this.options.defaultTime.split(":").map(Number);
    return {
      once: {
      },
      repeatSelected: false,
      repeat: {
        hours: 1,
        minutes: 0,
      },
      startingSelected: false,
      starting: {
        hours: this.getAmPmHour(defaultHours), 
        minutes: 0,
        hourType: this.getHourType(defaultHours),
        at: "00:00"
      },
      duration: {
        hours: 0,
        minutes: 0
      },
      daily: {
        days: 1
      },
      weekly: {
        weeks: 1,
        MON: true,
        TUE: false,
        WED: false,
        THU: false,
        FRI: false,
        SAT: false,
        SUN: false,
      },
      monthly: {
        months: [],
        subTab: "specificDays",
        specificDays: {
          days: [],
        },
        specificDaysOfWeek: {
          on: [],
          weekDays: []
        }
      }
    };
  }

  private cronIsValid(cron: string): boolean {
    if (cron) {
      const cronParts = cron.split(" ");
      return (
        (this.isCronFlavorQuartz &&
          (cronParts.length === 6 || cronParts.length === 7)) ||
        (this.isCronFlavorStandard && cronParts.length === 5)
      );
    }

    return false;
  }

  private handleModelChange(cron: string) {
    if (this.isDirty) {
      this.isDirty = false;
      return;
    } else {
      this.isDirty = false;
    }

    if (cron === "") {
      this.formGroup.controls.interval.setValue("once");
      return;
    }

    if (!this.cronIsValid(cron)) {
      this.formGroup.controls.interval.setValue("once");
      return;
    }

    const origCron: string = cron;
    if (cron.split(" ").length === 5 && this.isCronFlavorStandard) {
      cron = `0 ${cron} *`;
    }

    const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] =
      cron.split(" ");

    if (cron.match(/\d+ 0\/\d+ \* 1\/1 \* [\?\*] \*/)) {
      this.setInterval("once");
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ 1\/1 \* [\?\*] \*/) || cron.match(/\d+ \d+ \d+\-\d+\/\d+ 1\/1 \* [\?\*] \*/)) {
      this.setInterval("once");
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ 1\/1 \* [\?\*] \*/)) {
      this.setInterval("once");
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ 1\/\d+ \* [\?\*] \*/) || cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ 1\/\d+ \* [\?\*] \*/)) {
      this.setInterval("daily");
      this.state.days = parseInt(dayOfMonth.split("/")[1], 10);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ 1\/\d+ \* [\?\*] \*/)) {
      this.setInterval("daily");
      this.state.days = parseInt(dayOfMonth.split("/")[1], 10);
      this.setAdvancedState(cron);
      return
    }

    if (cron.match(/\d+ \d+ \d+ 1\/\d+ \* [\?\*] \*/)) {
      this.setInterval("daily");
      this.state.days = parseInt(dayOfMonth.split("/")[1], 10);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = 1;
      this.setDaysOfWeek(cron);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = parseInt(hours.split("/")[1], 10) / 7;
      this.setDaysOfWeek(cron);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = parseInt(hours.split("/")[1], 10) / 7;
      this.setDaysOfWeek(cron);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = parseInt(hours.split("/")[1], 10) / 7;
      this.setDaysOfWeek(cron);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = 1;
      this.setDaysOfWeek(cron);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = 1;
      this.setDaysOfWeek(cron);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDays";
      this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDays";
      this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDays";
      this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDaysOfWeek";
      let weekdayParts = dayOfWeek.split("#");
      this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDaysOfWeek";
      let weekdayParts = dayOfWeek.split("#");
      this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDaysOfWeek";
      let weekdayParts = dayOfWeek.split("#");
      this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    this.processOldCrons(cron);
  }

  processOldCrons(cron: string): void {
    const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] =
      cron.split(" ");

    if (cron.match(/\d+ 0\/\d+ \* 1\/1 \* [\?\*] \*/)) {
      this.setInterval("once");
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ 0\/\d+ 1\/1 \* [\?\*] \*/)) {
      this.setInterval("once");
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ 1\/\d+ \* [\?\*] \*/)) {
      this.setInterval("daily");
      this.state.days = parseInt(dayOfMonth.split("/")[1], 10);
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+ \* \* [\*\?] \*/) || cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ \* \* [\*\?] \*/)) {
      this.setInterval("daily");
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] \* MON-FRI \*/)) {
      this.setInterval("weekly");
      this.state.weekly.weeks = 1;
      this.selectOptions.weekDays.forEach(
        (weekDay) => (this.state.weekly[weekDay] = true)
      );
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/) ||
        cron.match(/\d+ \d+\/\d+ \d+\-\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/) ||
        cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      this.setInterval("weekly");
      this.selectOptions.days.forEach(
        (weekDay) => (this.state.weekly[weekDay] = false)
      );
      dayOfWeek
        .split(",")
        .forEach((weekDay) => (this.state.weekly[weekDay] = true));
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ (\d+|L|LW|1W) 1\/\d+ [\?\*] \*/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDays";
      this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.setAdvancedState(cron);
      return;
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] 1\/\d+ (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      this.setInterval("monthly");
      this.state.monthly.subTab = "specificDaysOfWeek";
      let weekdayParts = dayOfWeek.split("#");
      this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      this.state.monthly.months = months.includes("*") ? [] : months;
      this.noAdvancedState();
      return;
    }
  }

  checkCron(): string {
    return this.checkCronInterval(this._cron);
  }

  private setInterval(tab: string): void {
    this.formGroup.controls.interval.setValue(tab);
  }

  private checkCronInterval(cron: string): string {
    if (cron == undefined) {
      return "undefined";
    }

    if (cron == "") {
      this.setInterval("once");
      return "once0";
    }

    if (!this.cronIsValid(cron)) {
      this.setInterval("once");
      return "once - error";
    }

    const origCron: string = cron;
    if (cron.split(" ").length === 5 && this.isCronFlavorStandard) {
      cron = `0 ${cron} *`;
    }

    const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] =
      cron.split(" ");
    const [defaultHours, defaultMinutes] =
      this.options.defaultTime.split(":").map(Number);

    if (cron.match(/\d+ 0\/\d+ \* 1\/1 \* [\?\*] \*/)) {
      // this.setInterval("once");
      //this.noAdvancedState();
      return "once1";
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ 1\/1 \* [\?\*] \*/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ 1\/1 \* [\?\*] \*/)) {
      //this.setInterval("once");
      //this.setAdvancedState(cron);
      return "once2";
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ 1\/1 \* [\?\*] \*/)) {
      //this.setInterval("once");
      //this.setAdvancedState(cron);
      return "once3";
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ 1\/\d+ \* [\?\*] \*/) || cron.match(/\d+ \d+ \d+\-\d+\/\d+ 1\/\d+ \* [\?\*] \*/)) {
      //this.setInterval("daily");
      //this.state.hours = parseInt(hours.split("/")[1], 10);
      //this.setAdvancedState(cron);
      return "daily1";
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ 1\/\d+ \* [\?\*] \*/)) {
      //this.setInterval("daily");
      //this.state.hours = parseInt(hours.split("/")[1], 10);
      //this.setAdvancedState(cron);
      return "daily2";
    }

    if (cron.match(/\d+ \d+ \d+ 1\/\d+ \* [\?\*] \*/)) {
      //this.setInterval("daily");
      //this.state.hours = parseInt(hours.split("/")[1], 10);
      //this.noAdvancedState();
      return "daily3";
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      //this.setInterval("weekly1");
      //this.state.weekly.weeks = 1;
      //this.setDaysOfWeek(cron);
      //this.noAdvancedState();
      return "weekly1";
    }

    if (cron.match(/\d+ \d+ \d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      //this.setInterval("weekly1");
      //this.state.weekly.weeks = parseInt(hours.split("/")[1], 10) / 7;
      //this.setDaysOfWeek(cron);
      //this.noAdvancedState();
      return "weekly2";
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/) ||
      cron.match(/\d+ \d+ \d+\-\d+\/\d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      //this.setInterval("weekly");
      //this.state.weekly.weeks = parseInt(hours.split("/")[1], 10) / 7;
      //this.setDaysOfWeek(cron);
      //this.setAdvancedState(cron);
      return "weekly4";
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ \d+\/\d+ \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      //this.setInterval("weekly");
      //this.state.weekly.weeks = parseInt(hours.split("/")[1], 10) / 7;
      //this.setDaysOfWeek(cron);
      //this.setAdvancedState(cron);
      return "weekly5";
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/) ||
      cron.match(/\d+ \d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      //this.setInterval("weekly");
      //this.state.weekly.weeks = 1;
      //this.setDaysOfWeek(cron);
      //this.setAdvancedState(cron);
      return "weekly7";
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ [\*\?] \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
      //this.setInterval("weekly");
      //this.state.weekly.weeks = 1;
      //this.setDaysOfWeek(cron);
      //this.setAdvancedState(cron);
      return "weekly8";
    }

    if (cron.match(/\d+ \d+ \d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)) {
      //this.setInterval("monthly");
      //this.state.monthly.subTab = "specificDays";
      //this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      //this.state.monthly.months = months.includes("*") ? [] : months;
      //this.noAdvancedState();
      return "monthly3";
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)) {
      //this.setInterval("monthly");
      //this.state.monthly.subTab = "specificDays";
      //this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      //this.state.monthly.months = months.includes("*") ? [] : months;
      //this.setAdvancedState(cron);
      return "monthly3a";
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ (\d+|L|LW|1W)[,(\d+|L|LW|1W)]* [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC][,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* [\?\*]/)) {
      //this.setInterval("monthly");
      //this.state.monthly.subTab = "specificDays";
      //this.state.monthly.specificDay.day = dayOfMonth.split(",");
      let months = month.split(",");
      //this.state.monthly.months = months.includes("*") ? [] : months;
      //this.setAdvancedState(cron);
      return "monthly3b";
    }

    if (cron.match(/\d+ \d+ \d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      //this.setInterval("monthly");
      //this.state.monthly.subTab = "specificDaysOfWeek";
      //let weekdayParts = dayOfWeek.split("#");
      //this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      ///this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      //this.state.monthly.months = months.includes("*") ? [] : months;
      //this.noAdvancedState();
      return "monthly9";
    }

    if (cron.match(/\d+ \d+\/\d+ \d+\-\d+\/\d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)
      || cron.match(/\d+ \d+ \d+\-\d+\/\d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      //this.setInterval("monthly");
      //this.state.monthly.subTab = "specificDaysOfWeek";
      //let weekdayParts = dayOfWeek.split("#");
      //this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      ///this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      //this.state.monthly.months = months.includes("*") ? [] : months;
      //this.setAdvancedState(cron);
      return "monthly9a";
    }

    if (cron.match(/\d+ \d+\-\d+\/\d+ \d+\-\d+\/\d+ [\?\*] [*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)]* (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
      //this.setInterval("monthly");
      //this.state.monthly.subTab = "specificDaysOfWeek";
      //let weekdayParts = dayOfWeek.split("#");
      //this.state.monthly.specificDaysOfWeek.on = weekdayParts.length == 1 ? [] : [weekdayParts[1]];
      ///this.state.monthly.specificDaysOfWeek.weekDays = [weekdayParts[0]];
      let months = month.split(",");
      //this.state.monthly.months = months.includes("*") ? [] : months;
      //this.setAdvancedState(cron);
      return "monthly9b";
    }

    return "unknown";
  }

  private setDaysOfWeek(cron: string) {
    const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] = cron.split(" ");
    dayOfWeek
      .split(",")
      .forEach((weekDay) => (this.state.weekly[weekDay] = true));
  }

  private noAdvancedState() {
    this.state.repeatSelected = false;
    this.state.repeat.hours = 1;
    this.state.repeat.minutes = 0;
    this.state.startingSelected = false;
    this.state.starting.hours = 0;
    this.state.starting.minutes = 0;
    this.state.starting.hourType = "";
    this.state.starting.at = null;
    this.state.duration.hours = 0;
    this.state.duration.minutes = 0;
  }

  private setAdvancedState(cron: string) {
    const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] = cron.split(" ");
    const [defaultHours, defaultMinutes] = this.options.defaultTime.split(":").map(Number);
    this.state.repeatSelected = hours.includes("/") || minutes.includes("/");
    let hour = hours.includes("/") ? hours.split("/")[1] : hours;
    let minute = minutes.includes("/") ? minutes.split("/")[1] : minutes;
    this.state.repeat.hours = hour == "*" ? 0 : hours.includes("/") ? parseInt(hour, 10) : 0;
    this.state.repeat.minutes = minute == "*" ? 0 : minutes.includes("/") ? parseInt(minute, 10) : 0;
    let hourlyRange = hours.includes("/") ? hours.split("/")[0] : hours;
    let hRange = hourlyRange.includes("-") ? hourlyRange.split("-") : hours.includes("/") ? [ "0", "0" ] : [ hour, "0" ];
    let minuteRange = minutes.includes("/") ? minutes.split("/")[0] : minutes;
    let mRange = minuteRange.includes("-") ? minuteRange.split("-") : minutes.includes("/") ? [ "0", "0" ] : [ minute, "0" ];
    this.state.startingSelected = this.startingSelected; // this._starttime != "00:00" && this._starttime != ""; // hRange[0] != "0" || mRange[0] != "0";
    if (this.state.startingSelected) {
      this.state.starting.hours = parseInt(this._starttime.split(":")[0], 10);
      this.state.starting.minutes = parseInt(this._starttime.split(":")[1], 10);
      this.state.starting.at = this._starttime;
    }
    else {
      this.state.starting.hours = this.start.getHours(); // this.getAmPmHour(defaultHours);
      this.state.starting.minutes = this.start.getMinutes(); // 0;
      this.state.starting.hourType = this.getHourType(defaultHours);
      this.state.starting.at = this.start.getHours() + ":" + this.start.getMinutes(); // null;
    }

    this.state.duration.days = 0;
    if (hRange[1] == "0") {
      this.state.duration.hours = 0;
      this.state.duration.minutes = 0;
    }
    else {
      this.state.duration.hours = parseInt(hRange[1], 10) - this.state.starting.hours;
      if (this.state.duration.hours < 0) {
        this.state.duration.hours += this.state.starting.hours;
      }

      if (this.state.duration.hours >= 0) {
        this.state.duration.hours++;
      }

      this.state.duration.minutes = parseInt(mRange[1], 10) - this.state.starting.minutes;
      if (this.state.duration.minutes < 0) {
        this.state.duration.minutes += this.state.starting.minutes;
      }

      if (this.state.duration.minutes > 0) {
        this.state.duration.minutes++;
      }
    }
  }

  private getRange(start: number, end: number): number[] {
    const length = end - start + 1;
    return Array.apply(null, Array(length)).map((_, i) => i + start);
  }

  private getSelectOptions() {
    return {
      months: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthWeeks: ["#1", "#2", "#3", "#4", "L"],
      monthWeeksNames: ["First", "Second", "Third", "Fourth", "Last"],
      days: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
      weekDays: ["MON", "TUE", "WED", "THU", "FRI" ],
      dayNames: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      minutes: this.getRange(0, 59),
      fullMinutes: this.getRange(0, 59),
      seconds: this.getRange(0, 59),
      hours: this.getRange(1, 23),
      monthDays: this.getRange(1, 31),

      monthDaysWithLasts: [
        "1W",
        ...[...this.getRange(1, 31).map(String)],
        "LW",
        "L",
      ],
      monthDaysWithOutLasts: [...[...this.getRange(1, 31).map(String)]],
      hourTypes: ["AM", "PM"],
      use24HourTime: true
    };
  }

  public monthDayDisplay(month: string): string {
    if (month === "L") {
      return "Last Day";
    } else if (month === "LW") {
      return "Last Weekday";
    } else if (month === "1W") {
      return "First Weekday";
    } else {
      return `${month}${this.getOrdinalSuffix(month)}`;
    }
  }

  timezoneChanged(timezonePicker: TimezonePickerComponent) {
    this.schedule.timezone = timezonePicker.currentTimezone;
  }

  get start(): Date {
    return this._start;
  }
  set start(value: Date) {
    this._schedule.start = value;
    this._start = value;
  }
  private _start: Date = new Date();
  private _starttime: string = "00:00";

  get end(): Date {
    return this._end;
  }
  set end(value: Date) {
    this._schedule.end = value;
    this._end = value;
  }
  private _end: Date = new Date();

  get cron(): string {
    return this._cron;
  }
  set cron(value: string) {
    this._schedule.cron = value;
    this._cron = value;
  }
  private _cron = "0 0 0 1 1 *";

  computeForTab() {
    this.prevCron = "";
    if (this.startTime) {
      this.startTime.error = (this.start > this.end);
      this.endTime.error = (this.start > this.end);
    }

    if (this.start > this.end) {
      return;
    }

    switch (this.getInterval()) {
      case "once":
        this.computeOnceCron(this.state);
        break;
      case "daily":
        this.computeDailyCron(this.dailyForm.value);
        break;
      case "weekly":
        this.computeWeeklyCron(this.weeklyForm.value);
        break;
      case "monthly":
        this.computeMonthlyCron(this.monthlyForm.value);
        break;
    }

    this.scheduleChange.emit(this.schedule);
  }

  get yearDefaultChar() {
    return this.options.cronFlavor === "quartz" ? "*" : "";
  }

  get weekDayDefaultChar() {
    return this.options.cronFlavor === "quartz" ? "?" : "*";
  }

  get monthDayDefaultChar() {
    return this.options.cronFlavor === "quartz" ? "?" : "*";
  }

  private computeOnceCron(state: any) {
    this.computeAdvancedCron(state, `1/1 * ? ${this.yearDefaultChar}`);
  }

  private getTimeElement(time: string, element: number): number {
    try {
      let x = time.split(" ");
      let elements = x[0].split(":");
      return Number(elements[element]) + (element == 0 && x[x.length - 1] == "PM" ? 12 : 0);
    }
    catch {
      return 0;
    }
  }

  private computeDailyCron(state: any) {
    let theRest = `1/${state.days} * ${this.weekDayDefaultChar} ${this.yearDefaultChar
      }`.trim();
    this.computeAdvancedCron(this.advancedForm.value, theRest);
  }

  private computeWeeklyCron(state: any) {
    const days = this.selectOptions.days
      .reduce((acc: string[], day: string) => (state[day] ? acc.concat([day]) : acc), [])
      .join(",");
    let weeks = state.weeks > 1 ? "1/" + (state.weeks * 7) : "?";
    let theRest = `${weeks} * ${days} ${this.yearDefaultChar}`;
    this.computeAdvancedCron(this.advancedForm.value, theRest);
  }

  private computeMonthlyCron(state: any) {
    let months = state.months.join(",");
    if (months == "") {
      months = "*";
    }

    let days = "";
    let weekDays = "";
    switch (state.subTab) {
      case "specificDays":
        days = state.specificDays.days.join(",");
        break;
      case "specificDaysOfWeek":
        weekDays = state.specificDaysOfWeek.weekDays + state.specificDaysOfWeek.on;
        break;
    }

    if (days == "") {
      days = "?";
    }

    if (weekDays == "") {
      weekDays = "?";
    }

    let theRest = `${days} ${months} ${weekDays} *`;
    this.computeAdvancedCron(this.advancedForm.value, theRest);
  }

  private computeAdvancedCron(state: any, theRest: string) {
    /*if (state.repeatSelected == false && this.getInterval() == "once") {
      this.cron = ""; // 0 " + theRest;
      return;
    }*/

    // let startingSelected = true; state.startingSelected;
    let stm = state.startingSelected ? `${this.getTimeElement(state.starting.at, 1)}` : this.start.getMinutes().toString();
    let sth = state.startingSelected ? `${this.getTimeElement(state.starting.at, 0)}` : this.start.getHours().toString();
    let rh = state.repeatSelected ? state.repeat?.hours ?? "0" : "0";
    let rm = state.repeatSelected ? state.repeat?.minutes ?? "0" : "0";
    if (rm > 0) {
      if (stm != "0" && rm != "0") {
        let stme = parseInt(stm);
        let rme = parseInt(rm);
        while (stme > 0) {
          stme -= rme;
        }

        stme += rme;
        stm = stme.toString();
      }
      else {
        stm = "0";
      }
    }

    if (state.repeatSelected && rh == "0") {
      rh = "1";
    }

    let dme = (state.duration?.minutes ?? 0) == 0 ? 0 : (state.duration?.minutes ?? 0) + (state.startingSelected ? state.starting?.minutes : this.start.getMinutes()) - 1;
    if (dme > 59) {
      dme = 59;
    }
    if (dme < 0) {
      dme = 0;
    }

    let dm = state.repeatSelected && dme != 0 ? "-" + dme : "";
    let dhe = (state.duration?.hours ?? 0) == 0 ? 0 : (state.duration?.hours ?? 0) + (state.startingSelected ? state.starting?.hours : this.start.getHours()) - 1;
    if (dhe > 23) {
      dhe = 23;
    }
    if (dhe < 0) {
      dhe = 0;
    }

    let dh = state.repeatSelected || dhe == 1 ? "-" + dhe : "";
    let fm = state.repeatSelected ? stm + dm + "/" + rm : stm;
    if (fm == "0/0") {
      fm = "0";
    }

    let fh = state.repeatSelected && dh != "" ? sth + dh + "/" + rh : sth;
    if (fh == "0/0") {
      fh = "0";
    }

    this.cron = `${this.isCronFlavorQuartz ? "0" : "" } ${fm} ${fh} ${theRest}`.trim();
  }

  get cronDescription(): string {
    if (this.cron === "0 0 1 1 *") {
      return "";
    }

    return " - " + this.cron;
  }

  get cronBasicDescription(): string {
    if (this.cron == "" || this.cron == undefined) {
      return "Once";
    }

    try {
      let desc = cronstrue.toString(this.cron);
      if (this._starttime != "00:00" && this._starttime != "" && desc.startsWith("At 0 minutes")) {
        return desc.replace("At 0 minutes past the hour,", `beginning at ${this._starttime},`);
      }

      return desc;
    }
    catch {
      return "";
    }
  }

  @Input()
  get schedule(): Schedule | null {
    this._schedule.start = this.adjustTime(this.start, -this.tz);
    this._schedule.end = this.adjustTime(this.end, -this.tz);
    this._schedule.cron = this.cron;
    this._schedule.startingSelected = this.startingSelected;
    this._schedule.at = this._starttime == "" ? "00:00" : this._starttime;
    return this._schedule;
  }
  set schedule(value: Schedule | null) {
    this._schedule = value;
    this.defaultTimezone = value.timezone;
    if (this.start == this.adjustTime(value.start, this.tz) && this.end === this.adjustTime(value.end, this.tz) && this._cron == value.cron) {
      return;
    }

    this.tz = (this.start.getTimezoneOffset() ?? 0);
    this._start = this.adjustTime(value.start, this.tz);
    this._end = this.adjustTime(value.end, this.tz);
    this.startingSelected = value.startingSelected;
    this._starttime = value.at; // this.start.getHours() + ":" + this.start.getMinutes(); // value.at;
    this._cron = value.cron;
    this.setupForm();
  }
  private _schedule: Schedule;

  @Output()
  scheduleChange = new EventEmitter<Schedule>();

  @Input()
  get showTimezone(): boolean {
    return this._showTimezone;
  }
  set showTimezone(value: boolean) {
    this._showTimezone = value;
  }
  private _showTimezone: boolean = true;

  adjustTime(value: Date, offset: number) {
    let date = new Date(value);
    date.setMinutes(date.getMinutes() + offset);
    return date;
  }

  createAdjustedSchedule(schedule: Schedule) {
    schedule.start = this.adjustTime(schedule.start, -this.tz);
    schedule.end = this.adjustTime(schedule.end, -this.tz);
    return schedule;
  }

  get startOffset(): Date {
    return moment(this.start).add(this.tz, 'm').toDate();
  }

  get endOffset(): Date {
    return moment(this.end).add(this.tz, 'm').toDate();
  }

  private hourToCron(hour: number, hourType: string) {
    if (this.options.use24HourTime) {
      return hour == 24 ? 0 : hour > 24 ? hour - 12 : hour;
    } else {
      return hourType === "AM"
        ? hour === 12
          ? 0
          : hour
        : hour === 12
          ? 12
          : hour + 12;
    }
  }

  get isCronFlavorQuartz() {
    return this.options.cronFlavor === "quartz";
  }

  get isCronFlavorStandard() {
    return this.options.cronFlavor === "standard";
  }

  private getOrdinalSuffix(value: string) {
    if (value.length > 1) {
      const secondToLastDigit = value.charAt(value.length - 2);
      if (secondToLastDigit === "1") {
        return "th";
      }
    }

    const lastDigit = value.charAt(value.length - 1);
    switch (lastDigit) {
      case "1":
        return "st";
      case "2":
        return "nd";
      case "3":
        return "rd";
      default:
        return "th";
    }
  }

  private getAmPmHour(hour: number) {
    return this.options.use24HourTime ? hour : ((hour + 11) % 12) + 1;
  }

  private getHourType(hour: number) {
    return this.options.use24HourTime ? undefined : hour >= 12 ? "PM" : "AM";
  }

  getInterval() {
    return this.formGroup.controls.interval.value;
  }

  timeChanged(time: any) {
    this.start = time;
    this.computeForTab();
  }

  endTimeChanged(time: any) {
    this.end = time;
    this.computeForTab();
  }

  showDate(index: number): boolean {
    if (index == 0) {
      return true;
    }

    return (this.getDate(this.times[index]) != this.getDate(this.times[index - 1]));
  }

  getDate(date: Date): string {
    return date.getDate().toString() + date.getMonth() + date.getFullYear();
  }


  private _processingTimes = false;
  getNextTimes(limit: number): number {
    try {
      if (this.cron == this.prevCron) {
        return this.times.length;
      }

      this.prevCron = this.cron
      this.times = [];
      let offset = moment.tz(this._schedule.timezone).utcOffset();
      let now = new Date();
      if (this.start > now) {
        now = new Date(this.start);
        let rh = this.state.repeatSelected ? this.state.repeat?.hours ?? 0 : 0;
        let rm = this.state.repeatSelected ? this.state.repeat?.minutes ?? 0 : 0;
        let stm = this.state.startingSelected ? this.getTimeElement(this.state.starting.at, 1) : this.start.getMinutes();
        let sth = this.state.startingSelected ? this.getTimeElement(this.state.starting.at, 0) : this.start.getHours();
        now.setMinutes(stm);
        now.setHours(sth);
        if (rh == 0 && rm == 0) {
          now = moment(now).subtract(1, 'minutes').toDate();
        }
        else {
          if (rm == 0) {
            now = moment(now).subtract(rh, 'hours').toDate();
          }
          else {
            now = moment(now).subtract(rm, 'minutes').toDate();
          }
        }
      }

      now.setSeconds(0);
      now.setMilliseconds(0);
      now = this.adjustTime(now, -this.tz);
      if (this._processingTimes) {
        return this.times.length;
      }

      this._processingTimes = true;
      this.processService.getSchedule(this.cron, now, 50).subscribe(result => {
        let dates = result as string[];
        for (let i = 0; i < dates.length; i++) {
          let date = this.adjustTime(new Date(dates[i]), this.tz);

          // console.log("Processing date: " + dates[i] + ", " + new Date(dates[i]) + ", " + date);
          if (date > this.end) {
            break;
          }

          if (this.datetimeAdapter.compareDateWithTime(date, this.start) >= 0) {
            if (this.state.startingSelected) {
              let startDateTime = this.adjustTime(new Date(date), this.tz);
              startDateTime.setHours(this.state.starting.hours, this.state.starting.minutes, 0);
              if (this.datetimeAdapter.compareDateWithTime(date, startDateTime) >= 0) {
                this.times.push(date);
              }
            }
            else {
              this.times.push(date);
            }
          }

          if (this.times.length == limit) {
            break;
          }
        }

        this._processingTimes = false;
      });
      return this.times.length;
    }
    catch (error) {
      return 0;
    }
  }
  times: Date[] = [];
  prevCron: string = "";
}
